function suffixes(...suffixes) {
    return function (...names) {
        const mapped = {};

        names.forEach((name) => {
            suffixes.forEach((suffix) => {
                const fullName = `${name}_${suffix}`;
                mapped[fullName] = fullName;
            });
        });

        return mapped;
    }
}

export const requestSuccessFailure = suffixes('REQUESTED', 'SUCCESS', 'FAILURE');

export const openClosed = suffixes('OPEN', 'CLOSED');

export function names(...names) {
    const constants = {};

    names.forEach((name) => constants[name] = name);

    return constants;
}
